'use client';
import React, { useState } from 'react';
import Modal from '@/components/modal/Modal';
import { ModalSearchProps } from '@/components/modal/types';
import SearchComponent from '@/components/search/SearchComponent';

const SearchModal: React.FC<ModalSearchProps> = ({
  isOpen,
  size = 'large',
  ariaLabel = 'Search Modal',
  onClose,
  className,
  ...props
}) => {
  const [query, setQuery] = useState('');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      animation="fade"
      size={size}
      ariaLabel={ariaLabel}
      {...props}
    >
      <Modal.Body>
        <div className="relative mx-auto max-w-[900px] rounded-2xl bg-white">
          <div className="absolute inset-0 z-0 rounded-b-2xl opacity-50" />
          <div className="relative z-10">
            <SearchComponent
              query={query}
              setQuery={setQuery}
              onClose={onClose}
              className="w-full"
              isOpen={isOpen}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SearchModal;
